export const FACTORY_ADDRESS = "0x40be1cba6c5b47cdf9da7f963b6f761f4c60627d";
export const BUNDLE_ID = "1";
